import { Form, Modal } from "antd";
import { EnvironmentOutlined } from "@ant-design/icons";

interface LocationPickerViewProps {
  visible?: boolean;
  onClickLocation: (id: string) => void;
  onClose: (status: boolean) => void;
  activeLocation: any;
  locations?: any[] | null;
}

const LocationPickerView = ({
  visible,
  onClickLocation,
  onClose,
  activeLocation,
  locations,
}: LocationPickerViewProps) => {
  const [form] = Form.useForm();

  const iconStyle = { fontSize: 30, borderRadius: 30 };

  const onCancel = () => {
    form.resetFields();
    onClose(false);
  };

  const onClickLocationHandler = (location: any) => {
    onClickLocation(location._id);
  };

  return (
    <div className="location_modal">
      <Modal
        forceRender
        open={visible}                  // ✅ replaces deprecated `visible`
        centered
        className="address_modal_container success-modal"
        cancelText="Cancel"
        onCancel={onCancel}
        width={250}
        style={{ borderRadius: 5 }}
        footer={false}
        cancelButtonProps={{ style: { display: "none" } }}
        closable={false}
        mask={{ closable: false }}
      >
        <div className="modal_icon_container">
          <div className="modal_icon">
            <EnvironmentOutlined style={{ ...iconStyle, color: "#FFFFFF" }} />
          </div>
        </div>
        <div className="margin-bottom-10px margin-top-10px">
          {locations && locations.map((location: any, i: number) => (
            <div
              key={i.toString()}
              className={
                activeLocation && activeLocation === location.name
                  ? "location_suggestion_active location_suggestion"
                  : "location_suggestion"
              }
              onClick={() => onClickLocationHandler(location)}
            >
              {location.name ?? ""}
            </div>
          ))}
        </div>
      </Modal>
    </div>
  );
};

export default LocationPickerView;